import { IFeatureFlagsConfig, staticFlags } from 'shared-modules-angular/feature-flags';

import { environment } from '../../../environments/environment';

const env = staticFlags(environment);

export type UtDesktopMode = 'corrosion' | 'stitchingAndMerging' | 'zeroDegrees';

export type StaticFeature = 'cScanThickness' | 'deviceManager' | 'firingSequence' | 'gateAndTcgSyncho' | 'mergeFiles' | 'scannerMenu' | 'showStickynotes' | 'tilingCanvas';
export type LicensedFeature = 'analysis' | 'inspection';
export type WorkInProgress = 'workInProgress';

export type UtDesktopModeFeature =
  | 'automaticFlawDetection'
  | 'aScanBitDepth'
  | 'canAddIndicationWithoutNoiseZone'
  | 'canAlignData'
  | 'canStitchData'
  | 'materialLossReading'
  | 'snapToMinThickness'
  | 'snr'
  | 'zoneStatistics'
  | StaticFeature
  | LicensedFeature
  | WorkInProgress;

export const UT_DESKTOP_FEATURE_FLAGS_CONFIG: IFeatureFlagsConfig<UtDesktopModeFeature, UtDesktopMode> = {
  defaults: {
    // mode-controlled features: these are enabled/disabled based on the selected mode
    automaticFlawDetection: false,
    aScanBitDepth: false,
    canAddIndicationWithoutNoiseZone: false,
    canAlignData: false,
    canStitchData: false,
    materialLossReading: false,
    snapToMinThickness: false,
    snr: false,
    zoneStatistics: false,
    // static features: these are always enabled/disabled based on the environment
    cScanThickness: true,
    deviceManager: env.PC,
    firingSequence: env.PC,
    gateAndTcgSyncho: true,
    mergeFiles: env.PC,
    scannerMenu: true,
    showStickynotes: true,
    tilingCanvas: env.LOCAL,
    workInProgress: env.DEV || env.LOCAL,
    // licensed features: these are enabled/disabled based on the license
    analysis: false,
    inspection: false,
  },
  modes: {
    zeroDegrees: { features: ['snr', 'zoneStatistics'] },
    stitchingAndMerging: { features: ['aScanBitDepth', 'canAlignData', 'canStitchData'] },
    corrosion: { features: ['automaticFlawDetection', 'canAddIndicationWithoutNoiseZone', 'materialLossReading', 'snapToMinThickness', 'snr', 'zoneStatistics'] },
  },
  environments: {
    analysis: env.PC || env.LOCAL,
    inspection: env.PC || env.LOCAL,
  },
  dependencies: {
    automaticFlawDetection: ['analysis', 'workInProgress'],
    materialLossReading: ['analysis'],
    snapToMinThickness: ['analysis'],
    snr: ['analysis'],
    tilingCanvas: ['workInProgress'],
    zoneStatistics: ['analysis'],
  },
};
